/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { Avatar, Verified } from '@components/avatar';
import { Text, Button, Box, Tooltip } from '@components/design-system';
import { ICreator, IUser } from '@interface/token';
import { getURLFromIPFSorHTTP } from '@utils/ipfs';
import { getScreenName } from '@utils/user';
import * as Styles from './styles';

interface ICreatorsText {
  creators: ICreator[];
}

export const CreatorsText: FC<ICreatorsText> = ({ creators }) => {
  const router = useRouter();
  const list = creators.map((e: ICreator) => e.wallet.user[0].user);

  const separator = (current: number, total: number) => {
    if (current === total) {
      // return <>&nbsp;and&nbsp;</>;
      return '';
    }

    if (current > 0 && current < total) {
      // return <>,&nbsp;</>;
      return '';
    }

    return '';
  };

  return (
    <>
      {list.map((user: IUser, index: number) => {
        const screenName = getScreenName(user.verified_on_chain, user.screen_name, user.id, user.name);

        return (
          <Box key={user.id}>
            <Text unset css={{ fontSize: 14, color: '$secondaryFill' }}>
              {separator(index, list.length - 1)}
            </Text>
            <Link href={`/user/${user.id}/created`} locale={router.locale} prefetch={false} passHref>
              <Button as="a" variant="basic">
                <Box>
                  {screenName}
                  {user.verified_on_chain && <Verified size={10} secondary />}
                </Box>
              </Button>
            </Link>
          </Box>
        );
      })}
    </>
  );
};

export interface ICreators {
  creators: ICreator[];
  avatar?: boolean;
}

export const Creators: FC<ICreators> = ({ creators, avatar = false }) => {
  const router = useRouter();

  // make sure the creators aren't a KT1
  const sanitiseCreators = creators.filter((creator) => creator.wallet.user.length > 0);

  return (
    <Box vertical>
      {creators.length > 1 ? (
        <>
          {avatar && (
            <Styles.Creators>
              {sanitiseCreators.map(({ wallet }) => {
                const { user } = wallet;
                const screenName = getScreenName(
                  user[0].user.verified_on_chain,
                  user[0].user.screen_name,
                  user[0].user.id,
                  user[0].user.name
                );
                return (
                  <Tooltip key={user[0].user.id} description={screenName}>
                    <Link href={`/user/${user[0].user.id}/created`} locale={router.locale} prefetch={false} passHref>
                      <a>
                        <Avatar
                          username={user[0].user.id}
                          path={getURLFromIPFSorHTTP(user[0].user.profile_image_uri)}
                          size={32}
                        />
                      </a>
                    </Link>
                  </Tooltip>
                );
              })}
            </Styles.Creators>
          )}
          <Text unset css={{ color: '$secondaryFill', fontSize: 14 }}>
            Multiple creators
          </Text>
          {/* <CreatorsText creators={creators} /> */}
        </>
      ) : (
        <>
          {sanitiseCreators.map(({ wallet }) => {
            const { user } = wallet;
            const screenName = getScreenName(
              user[0].user.verified_on_chain,
              user[0].user.screen_name,
              user[0].user.id,
              user[0].user.name
            );
            return (
              <Box key={user[0].user.id} vertical>
                {avatar && (
                  <Tooltip key={user[0].user.id} description={screenName}>
                    <Link href={`/user/${user[0].user.id}/created`} locale={router.locale} prefetch={false} passHref>
                      <Button as="a" variant="basic">
                        <Styles.Creators>
                          <Avatar
                            username={user[0].user.id}
                            path={getURLFromIPFSorHTTP(user[0].user.profile_image_uri)}
                            size={32}
                          />
                        </Styles.Creators>
                      </Button>
                    </Link>
                  </Tooltip>
                )}

                <Link href={`/user/${user[0].user.id}/created`} locale={router.locale} prefetch={false} passHref>
                  <Button as="a" variant="basic">
                    <Box>
                      {screenName}
                      {user[0].user.verified_on_chain && <Verified size={10} secondary />}
                    </Box>
                  </Button>
                </Link>
              </Box>
            );
          })}
        </>
      )}
    </Box>
  );
};
